import { BaseHostMapComplete } from "../../lib";
const BaseProdHost = BaseHostMapComplete("mehiya.com");
const ProdHost = [
  // 最基本的
  BaseProdHost,
  // 动态域名新增的
  BaseHostMapComplete("raboaza.link"),
  BaseHostMapComplete("fuconnect.link"),
  BaseHostMapComplete("chatcoach.net"),
  BaseHostMapComplete("golfchat.net")
];
export {
  BaseProdHost,
  ProdHost
};
